import { useLocalStorage } from '@vueuse/core';
import { version } from '../../package.json';

import type { Ref } from '@vue/composition-api';

const currentVersion = useLocalStorage('version', version);

export function useVersion(): {
  currentVersion: Ref<string>;
} {
  return {
    currentVersion
  };
}
